<section class="container">
  <div class="row">
    <div class="col-lg-10 offset-lg-1">
      <neo-contentStyledText
        [text]="legalTxt"
      ></neo-contentStyledText>
    </div>
  </div>
</section>
